AuthRoute = require 'mixins/authenticated-route'

{ timedPromise } = require 'utils/rsvp'

App.ModifierGroupsIndexRoute = Em.Route.extend AuthRoute,
  model: ->
    @modelFor('modifier-groups')
